import { IconTooltip } from '@giphy/react-giphy-brand'
import { Fragment, PureComponent } from 'react'
import styled from 'styled-components'
import { FormInput, HeaderContainer, OptionalText } from '../form-components'
import FormHeader from '../form-header'
import GenderButtonGroup from '../inputs/gender-button-group'
import getBirthdayError, { dateRegEx } from '../get-birthday-error'

const GenderButtons = styled(GenderButtonGroup)`
    margin-bottom: 20px;
`

class OptionalFormInputs extends PureComponent {
    state = {}
    componentDidUpdate(prevProps, prevState) {
        const { hasDateError } = this.state
        if (hasDateError !== prevState.hasDateError) {
            const { onDateError } = this.props
            this.setState({ hasDateError })
            onDateError(hasDateError)
        }
    }
    onDateChange = val => {
        IconTooltip.hideToolTips()
        // make sure it matches the string
        this.isValidDate = dateRegEx.test(val)
        // is it too long ago or too recent
        this.dateErrorMessage = getBirthdayError(val)
        // block the submit if there is a date and it's wrong
        this.hasDateError = !!this.dateErrorMessage

        this.setState({ hasDateError: this.hasDateError })

        if (this.isValidDate) {
            this.validateDate()
        }
    }
    validateDate = () => {
        this.setState({
            dateError: !this.hasDateError ? '' : this.dateErrorMessage,
        })
    }
    render() {
        const { dateError } = this.state
        return (
            <Fragment>
                <HeaderContainer>
                    <FormHeader>Birthday</FormHeader>
                    <OptionalText>Optional</OptionalText>
                </HeaderContainer>
                <FormInput
                    errorMessage={dateError}
                    errorTooltip
                    inputProps={{
                        onChange: e => this.onDateChange(e.target.value),
                        onBlur: this.validateDate,
                        type: 'text',
                        name: 'birthdate',
                        placeholder: 'MM/DD/YYYY',
                        autoComplete: 'off',
                    }}
                />
                <HeaderContainer>
                    <FormHeader>Gender</FormHeader>
                    <OptionalText>Optional</OptionalText>
                </HeaderContainer>
                <GenderButtons />
            </Fragment>
        )
    }
}

export default OptionalFormInputs
